export default __webpack_public_path__ + "static/media/bank.dd3559cd.svg";